/*
Adapted from https://github.com/ianwalter/ng-context-menu with an MIT license.
*/
(function () {
    'use strict';
    angular.module('aprima-core-ui').directive('apContextMenu', [
        '$window',
        '$document',
        'AprimaAnalytics',
        '$log',
        'ClickListenerService',
        'PressListenerService',
        '$rootScope',
        '$parse',
        'Bridge',
        '$timeout',
        '$transitions',
        function apContextMenu(
            $window,
            $document,
            AprimaAnalytics,
            $log,
            ClickListenerService,
            PressListenerService,
            $rootScope,
            $parse,
            Bridge,
            $timeout,
            $transitions
        ) {
            var menuTracker = {
                element: null,
                menuElement: null
            };

            Bridge.on('navigate', $rootScope, broadcastCloseContextMenu);
            $transitions.onSuccess({}, function closeContextMenu() {
                //must do it in a timeout because it interferes with the current $digest cycle
                $timeout(broadcastCloseContextMenu, 0);
            });

            return {
                restrict: 'A',
                scope: false,
                link: link,
            };

            function broadcastCloseContextMenu() {
                $rootScope.$broadcast('close-context-menu');
            }

            function getBackdrop() {
                var element;
                var parent = $document.find('#context-menu-container');
                var backdrops = parent.find('.context-menu-backdrop');
                var deregisterFn = angular.noop;

                //add the backdrop if it isnt already on the page
                if (!backdrops.length) {
                    element = angular.element('<div class="context-menu-backdrop"></div>')[0];
                    parent.append(element);
                } else {
                    element = backdrops[0];
                }

                element = angular.element(element);

                return {
                    addBackdrop: addBackdrop,
                    removeBackdrop: removeBackdrop,
                };

                function addBackdrop(backdropClickHandler) {
                    element.addClass('on');
                    deregisterFn = ClickListenerService.register(element, backdropClickHandler);
                }

                function removeBackdrop() {
                    element.removeClass('on');
                    deregisterFn();
                }
            }

            function link(scope, element, attrs) {
                var opened = false;
                var backdrop = getBackdrop();
                var handleClick = attrs.apContextMenuOnClick ? !!JSON.parse(String(attrs.apContextMenuOnClick).toLowerCase()) : false;
                var openFn = attrs.apContextMenuOpen ? $parse(attrs.apContextMenuOpen) : angular.noop;
                var closeFn = attrs.apContextMenuClose ? $parse(attrs.apContextMenuClose) : angular.noop;
                var setPosition = _.isUndefined(attrs.apContextMenuSetPosition) ? true : !!$parse(attrs.apContextMenuSetPosition)();
                var lastEvent = null;
                var observer = new MutationObserver(function () {
                    if (lastEvent) {
                        resizeMenu(lastEvent, menuTracker.menuElement);
                    }
                });
                var deregisterClose = $rootScope.$on('close-context-menu', tryCloseContextMenu);
                var deregisterListener;

                //browser default right click menu event
                element.bind('contextmenu', handleOpenContextMenuEvent);

                if (handleClick) {
                    deregisterListener = ClickListenerService.register(element, handleOpenContextMenuEvent);
                } else {
                    deregisterListener = PressListenerService.register(element, handleOpenContextMenuEvent);
                }

                scope.$on('$destroy', cleanup);

                function openContextMenu(event) {
                    AprimaAnalytics.sendEvent('gestures', 'open-context-menu', attrs.apContextMenuType || '', 0);

                    var menuElement = menuTracker.menuElement;
                    //show and THEN calculate positional properties
                    menuElement.addClass('open');

                    lastEvent = event;
                    resizeMenu(event, menuElement);

                    //Track changes to the DOM tree so that if it changes, the menu will resize.
                    observer.observe(menuElement[0], {childList: true, subtree: true});

                    opened = true;

                    backdrop.addBackdrop(backdropClickHandler);
                }

                function resizeMenu(event, menuElement) {
                    if (!menuElement) {
                        return;
                    }

                    if (!event.pageX && event.pageX !== 0) {
                        AprimaAnalytics.sendEvent('gestures', 'open-context-menu', 'X,Y coords could not be found', 0);
                        $log.warn('Could not determine X,Y coordinates for ');
                    }

                    var doc = $document[0].documentElement,
                        docLeft = ($window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0),
                        docTop = ($window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0),
                        elementHeight = menuElement[0].scrollHeight,
                        elementWidth = menuElement[0].scrollWidth,
                        docHeight = doc.clientHeight + docTop,
                        totalHeight = event.pageY - elementHeight,
                        docWidth = doc.clientWidth + docLeft,
                        totalWidth = elementWidth + event.pageX,
                        top = Math.max(event.pageY - elementHeight - docTop, 0),
                        left = Math.max(event.pageX - docLeft, 0);

                    if (totalHeight > docHeight) {
                        top = top - (totalHeight - docHeight);
                    }

                    if (totalWidth  > docWidth) {
                        left = left - (totalWidth - docWidth);
                    }

                    if (setPosition) {
                        menuElement.css('top', top + 'px');
                        menuElement.css('left', left + 'px');
                    }

                    opened = true;

                    backdrop.addBackdrop(backdropClickHandler);
                }

                function tryCloseContextMenu() {
                    var menuElement = menuTracker.menuElement;
                    if (menuElement) {
                        menuElement.removeClass('open');

                        opened = false;

                        menuTracker.element = null;
                        menuTracker.menuElement = null;

                        backdrop.removeBackdrop();

                        closeFn(scope);
                    }
                }

                function handleOpenContextMenuEvent(event) {
                    scope.$apply(function() {
                        //manipulates hammerjs events to have needed properties in the same place as regular click events
                        var srcEvent = event.srcEvent;
                        var startEvent = event.startEvent;

                        if (event.center && event.center.x) {
                            event.pageX = event.center.x;
                            event.pageY = event.center.y;
                        } else if (srcEvent && srcEvent.pageX) {
                            event.pageX = srcEvent.pageX;
                            event.pageY = srcEvent.pageY;
                        } else if (startEvent) {
                            if (startEvent.x) {
                                event.pageX = startEvent.x;
                                event.pageY = startEvent.y;
                            } else if (startEvent.touches && startEvent.touches.length) {
                                var touch = startEvent.touches[0];
                                event.pageX = touch.pageX;
                                event.pageY = touch.pageY;
                            }
                        }

                        tryCloseContextMenu();

                        menuTracker.menuElement = angular.element(document.getElementById(attrs.apContextMenuTarget));
                        menuTracker.element = event.target;

                        openFn(scope);

                        event.preventDefault();

                        openContextMenu(event);
                    });
                }

                function backdropClickHandler() {
                    scope.$apply(tryCloseContextMenu);
                }

                function cleanup() {
                    element.unbind('contextmenu', handleOpenContextMenuEvent);

                    deregisterListener();
                    deregisterClose();

                    if (opened) {
                        tryCloseContextMenu();
                    }
                }
            }
        }
    ]);
})();